/* tslint:disable:import-spacing no-inferrable-types variable-name align no-trailing-whitespace */

import {Movement}        from '@/models/scenario/movement';
import {MovementDelay}   from '@/models/scenario/movement.delay';
import {Train}           from '@/models/scenario/train';
import {TrainClass}      from '@/models/scenario/train.class';
import {Logger}          from '@/util/logger';

import * as $            from 'jquery';
import 'bootstrap';

import {
  createGrid,
  GetGroupRowAggParams,
  GridOptions,
  GridReadyEvent,
  IRowNode
} from "ag-grid-community";
import { Track } from '@/models/scenario/track';

/**
 *
 * @class ConsistReportDialog
 *
 * @brief provides a modal dialog for summarizing a trains consist changes
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      May 2025
 *
 */
export class ConsistReportDialog {


  /** pop the dialog for this train movement */
  public static show(move: Movement, uuid: number) {

    let content: string;

    Logger.debug('[consist-report]', 'filling content: ', move);


    content = `
<div id="consist-report-summary-group_${uuid}" class="consist-report-summary-group">
  <span>Changes: <strong class="timedata">${move._parent._consistChanges.length}</strong></span>
</div>
<div
  id="ag-grid-consist-report-table_${uuid}"
  style="width: 100%; height: 400px;"
  class="ag-theme-balham-dark">
</div>`;

    let   title: string = '';
    const train: Train      = move._parent._train;

    title += train.generatedName();
    title += ' ' + TrainClass.typeToString(train._tc._dir);
    title += ' #' + train._id;
    title += ' Gen: ' + train.generatedID();

    const  html: string = `
<div id="consist-report-dialog_${uuid}" class="modal" style="padding: 0;" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content" style="padding:8px; background-color: #3C3F41;">
      <div class="modal-header">
        <h5 class="modal-title">Consist Report - ${title}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        ${content}
      </div>
      <div class="modal-footer">
        <button type="button" class="ok-button btn btn-primary">Ok</button>
      </div>
    </div>
  </div>
</div>`;

    /* create and show the dialog */

    Logger.debug('[consist-report]', 'popping..');

    $(`#three-string-viewer-container_${uuid}`).append(html);
    // @ts-ignore
    $(`#consist-report-dialog_${uuid}`).modal({});

    /* register a cleanup when it's done */

    $(`#consist-report-dialog_${uuid} button.ok-button`).on('click', (e) => {

      // @ts-ignore
      $(`#consist-report-dialog_${uuid}`).modal('hide');

    });

    $(`#consist-report-dialog_${uuid}`).on('hidden.bs.modal', (e) => {

      Logger.debug('[delay-report]', 'destructing..');

      $(`#consist-report-dialog_${uuid}`).remove();

    });

    /* dynamically create an ag-grid table ... */

    const id: string = `#ag-grid-consist-report-table_${uuid}`;

    Logger.debug(`[consist-report] waiting for host DOM... ${id}`);

    function waitForRender(time: DOMHighResTimeStamp): void {

      /*
       * instead of trying to do a timeout on the existence of the DOM, we check
       * if it exists AND has a rendered geometry...if not we just request an
       * animation frame. It will typically only take a couple of frames before
       * it gets rendered; Javascript is single threaded, so Angular or whatever
       * will do all of its jazz, and this element will pop up in the next frame.
       *
       */

      if ($(id).length == 0) {

        /* the window container has not even been created */

        window.requestAnimationFrame(waitForRender);

        /* keep waiting */

        return;
      }

      /* hosting element is ready...do our setup... */

      let el: HTMLElement = $(id).get()[0];

      Logger.debug('[consist-report] building on host DOM: ', el);

      /* setup table for automatic aggregation (roll up) ... */

      const columnDefs = [
        {
          headerName: 'DP',
          field: 'dp',
          width: 120
        },
        {
          headerName: 'Mile',
          field: 'mile',
          width: 120
        },
        {
          headerName: 'Track',
          field: 'track',
          width: 100
        },
        {
          headerName: 'Class',
          field: 'trainclass',
          width: 100
        },
        {
          headerName: 'Weight',
          field: 'weight',
          width: 100
        },
        {
          headerName: 'Length',
          field: 'length',
          width: 100
        },
        {
          headerName: 'Priority',
          field: 'priority',
          width: 100
        },
        {
          headerName: 'Overtake',
          field: 'overtake',
          width: 100
        }
      ];

      /* create the actual data */

      const rowData: any[] = [];

      for (const change of move._parent._consistChanges) {

        let trackLabel: string = Track.typeToString(change.move._track._type) + change.move._track._origTrack + ` (${change.move._track._id})`;

        const row = {
          dp:         change.move._dp._name,
          mile:       change.move._dp._mileage,
          track:      trackLabel,
          trainclass: change.consist._tc._name,
          weight:     change.consist._tonnage,
          length:     change.consist._length,
          priority:   change.consist._priority,
          overtake:   change.consist._overtake
        };

        rowData.push(row);
      }

      /* configure ... */

      const gridOptions: GridOptions = {

        columnDefs,

        rowData,

        onGridReady: (e: GridReadyEvent): void => {

          Logger.debug('[consist-report]', 'ready!');

        },

        enableRangeSelection: true,
        sideBar: true,

        defaultColDef:        {
          sortable: true,
          filter: true
        }

      };

      /* render */

      createGrid(el, gridOptions);

    }

    window.requestAnimationFrame(waitForRender);
  }
}

